<ix-label
  *ngIf="label || tooltip"
  [label]="label"
  [tooltip]="tooltip"
  [required]="required"
  [ixTestOverride]="controlDirective.name"
></ix-label>

<div class="input-container" [class.disabled]="isDisabled">
  <div>
    <label>
      {{ 'Choose File' | translate }}
      <input
        type="file"
        [accept]="acceptedFiles"
        [ixTest]="controlDirective.name"
        [required]="required"
        [disabled]="isDisabled"
        [multiple]="multiple"
        (change)="onChanged(asFileInput($event.target).files)"
      />
    </label>
  </div>
  <div *ngIf="value && value.length">
    <p *ngFor="let file of value" class="file">
      <span
        class="file-action"
        [matTooltip]="'Remove file' | translate"
        (click)="removeFile(file)"
      >
        <ix-icon name="close"></ix-icon>
      </span>
      <span class="file-name">{{ file.name }}</span>
      <span class="file-size">{{ formatSize(file.size) }}</span>
    </p>
  </div>
</div>
<ix-errors [control]="controlDirective.control" [label]="label"></ix-errors>
